import parent from '../../wgg/wgg.module';
import './mapOption.service'

export default parent.factory('mapService', mapService);

function mapService($rootScope, $timeout, $http, $window, mapOptions, $q, Settings) {

    //Attributes
    let map;
    let poiLayerSource = new ol.source.Vector();
    let extentLayerSource = new ol.source.Vector();
    let markerLayerSource = new ol.source.Vector();
    let displayLayers = [];
    let select, selectClick, selectPointerMove;
    let activePoiIds = [];

    /**
     * Elements that make up the popup.
     */
    var container = document.getElementById('popup');
    var content = document.getElementById('popup-content');

    /**
     * Create an overlay to anchor the popup to the map.
     */
    var overlay = new ol.Overlay({
        element: container,
        autoPan: true,
        autoPanAnimation: {
            duration: 250
        },
        offset: [0, -36]
    });


    let mapAPI = {
        getFeatureBy: getFeatureBy,
        getInitMapOptions: getInitMapOptions,
        getLayerByName: getLayerByName,
        initMap: initMap,
        loadLayer:  loadLayer,
        refreshPoiLayer: refreshPoiLayer,
        setActivePoiIds: setActivePoiIds,
        showLayer: showLayer,
        hideLayer: hideLayer,
        toggleLayer: toggleLayer,
        zoomToExtent: zoomToExtent,
        zoomToLayerFeatures: zoomToLayerFeatures,
        addPostMessageListener: addPostMessageListener
    };
    return mapAPI;

    function addPostMessageListener() {
        $window.addEventListener('message', receiveMessage);
    }

    //Public functions
    function initMap(initMapOptions, type) {
        // communication between iframe & app
        //$window.addEventListener('message', receiveMessage);

        addExtraOlFunctions();
        preInitialize();
        map = new ol.Map(initMapOptions);

        initZoningLayer(map);

        map.on('moveend', (evt)=> {
            //refreshPoiLayer()
        });


        //zoomToExtent(mapOptions.bbox);
        //zoomToLayerFeatures('zonesLayer');

        select = null;  // ref to currently selected interaction


        // select interaction working on "click"
        selectClick = new ol.interaction.Select({
            condition: ol.events.condition.click,
            style: highlightStyle
        });


        // select interaction working on "pointermove"
        selectPointerMove = new ol.interaction.Select({
            condition: ol.events.condition.pointerMove,
            style: highlightStyle
        });

        function highlightStyle(feature, resolution) {
            let color = 'rgba(255, 255, 255, 0.4)';

            if (angular.isDefined(feature.get('color'))) {
                let hexColor = feature.get('color');
                color = ol.color.asArray('#' + hexColor);
                color = color.slice();
                color[3] = 0.4;
            }

            var textStyle = new ol.style.Style(getTextStyleConfig(feature, resolution, true));
            var style = new ol.style.Style(getPolyStyleConfig(color, 1.5));
            return [style,textStyle];
        }


        selectPointerMove.on('select', function(e) {
            clearSelection();
        });


        selectClick.on('select', function(event) {
            let features = event.target.getFeatures();
            let feature = features.getArray()[0];
            let layer = feature.getLayer(map);
            let layerName = layer.get('name');

            let id = feature.get('id');
            let msg = {};
            msg.id = id;
            msg.mode = layerName.replace('Layer', '');

            window.parent.postMessage(msg, '*');

        });

        map.addInteraction(selectClick);
        map.addInteraction(selectPointerMove);


        setTimeout(function() {
            postInitialize();
        }, 200);

    }

    function addMarkerLayer() {

        const text = Settings.markerData.text;
        const coordinates = ol.proj.transform([Settings.markerData.x, Settings.markerData.y], 'EPSG:4326', 'EPSG:3857');

        var iconFeature = new ol.Feature({
            geometry: new ol.geom.Point(coordinates),
            type: 'marker',
            text: text
        });

        var iconStyle = new ol.style.Style({
            image: new ol.style.Icon(/** @type {module:ol/style/Icon~Options} */ ({
                anchor: [0.5, 46],
                anchorXUnits: 'fraction',
                anchorYUnits: 'pixels',
                src: 'dist/assets/img/marker.png'
            }))
        });

        iconFeature.setStyle(iconStyle);

        if (Settings.markerData.show_address == 1) {
            markerLayerSource.addFeature(iconFeature);
        }


        let markerLayer = new ol.layer.Vector({
            name: 'markerLayer',
            source: markerLayerSource,
            visible: true
        });

        map.getLayers().insertAt(9999, markerLayer);

        map.getView().animate({center: coordinates, zoom: 16});

        // display popup on pointermove
        map.on('pointermove', function(evt) {
            var feature = map.forEachFeatureAtPixel(evt.pixel,
                function(feature) {
                    return feature;
                });
            if (feature && feature.get('type') === 'marker') {
                const text = feature.get('text');
                content.innerHTML = text;
                const coords = feature.getGeometry().getCoordinates();
                overlay.setPosition(coordinates);

            } else {
                overlay.setPosition(null);
            }
        });

    }

    function receiveMessage(e) {

        if (angular.isDefined(e.data.val) && angular.isDefined(e.data.mode)) {

            let mode = e.data.mode;
            let id = parseInt(e.data.val);

            let targetLayer = getLayerByName('sectorsLayer');
            if (mode == 'zones') {
                targetLayer = getLayerByName('zonesLayer');
            }

            let targetSource = targetLayer.getSource();
            var featureToPush = getFeatureById(targetSource, id);
            if (featureToPush !== null) {
                clearSelection();
                selectClick.getFeatures().push(featureToPush);
                zoomToFeature(featureToPush);
            }

        }


    }

    function clearSelection() {
        selectClick.getFeatures().clear();
    }

    function zoomToFeature(feature) {
        map.getView().fit(feature.getGeometry(), map.getSize())
    }

    function getFeatureById(source, id) {
        let features = source.getFeatures();
        for( let i=0; i<features.length; i++) {
            let feature = features[i];
            let featureId = feature.get('id');
            if (featureId === id) {
                return feature;
            }
        }
        return null;
    }

    function getWigeoApiUrl() {
        return Settings.wigeoapiUrl;
    }

    function getWigeoApiKey() {
        return Settings.wigeoapiKey;
    }

    function getBaseUrl() {
        return Settings.baseUrl;
    }

    function initZoningLayer(map) {

        let parser = new ol.format.WMTSCapabilities();
        let url = 'https://maps.wien.gv.at/wmts/1.0.0/WMTSCapabilities.xml';


        $http.get(url).then(function(response) {

            let text = response.data;

            let result = parser.read(text);
            let options = ol.source.WMTS.optionsFromCapabilities(result, {
                layer: 'flwbplmzk',
                matrixSet: 'EPSG:3857'
            });

            let layer = new ol.layer.Tile({
                name: 'zoningLayer',
                opacity: 0.6,
                source: new ol.source.WMTS(options),
                visible: false
            });

            map.getLayers().insertAt(1, layer);
        });

    }

    function getInitMapOptions(callback) {

        let mapInitOptions = mapOptions.mapOpts;

        var parser = new ol.format.WMTSCapabilities();

        let sectorsSource =  new ol.source.Vector({
            format: new ol.format.GeoJSON(),
            url: 'dist/assets/data/sectors.json'
        });

        let districtsSource =  new ol.source.Vector({
            format: new ol.format.GeoJSON(),
            url: 'dist/assets/data/districts.json'
        });

        let zonesSource =  new ol.source.Vector({
            format: new ol.format.GeoJSON(),
            url: 'dist/assets/data/zones.json'
        });

        sectorsSource.once('change',function(e){
            if (sectorsSource.getState() === 'ready') { setLayersAndAreas(); }
        });

        districtsSource.once('change',function(e){
            if (districtsSource.getState() === 'ready') { setLayersAndAreas(); }
        });

        zonesSource.once('change',function(e){
            if (zonesSource.getState() === 'ready') { setLayersAndAreas(); }
        });



        mapInitOptions.overlays = [
            overlay
        ];
        mapInitOptions.layers = [
            new ol.layer.Tile({
                name: 'baseLayer',
                source: new ol.source.TileWMS({
                    url: getWigeoApiUrl() + 'map/index.php',
                    params: {
                        'LAYERS': mapOptions.baseLayer,
                        'KEY': getWigeoApiKey()
                    },
                    attributions: [
                        new ol.Attribution({
                            html: mapOptions.attribution
                        })
                    ]
                }),
                opacity: 1
            }),
            new ol.layer.Tile({
                name: 'satelliteLayer',
                source: new ol.source.TileWMS({
                    url: getWigeoApiUrl() + 'map/index.php',
                    params: {
                        'LAYERS': mapOptions.satelliteLayer,
                        'KEY': getWigeoApiKey()
                    },
                    attributions: [
                        new ol.Attribution({
                            html: mapOptions.attribution
                        })
                    ]
                }),
                visible: false,
                opacity: 1
            }),
            new ol.layer.Tile({
                name: 'labelLayer',
                source: new ol.source.TileWMS({
                    url: getWigeoApiUrl() + 'map/index.php',
                    params: {
                        'LAYERS': mapOptions.labelLayer,
                        'KEY': getWigeoApiKey()
                    },
                    attributions: [
                        new ol.Attribution({
                            html: mapOptions.attribution
                        })
                    ]
                }),
                visible: false,
                opacity: 1
            }),

            new ol.layer.Tile({
                name: 'transportLayer',
                source: new ol.source.TileWMS({
                    url: 'geoserver.php',
                    params: {
                        'LAYERS': 'standortwien:standortwienpublic'
                    }
                }),
                visible: false,
                opacity: 1
            }),

            new ol.layer.Vector({
                name: 'districtsLayer',
                source: districtsSource,
                visible: true,
                style: normalStyle.bind(this, false)
            }),

            new ol.layer.Vector({
                name: 'zonesLayer',
                source: zonesSource,
                visible: true,
                style: normalStyle.bind(this, Settings.hidezonefill)
            }),

            new ol.layer.Vector({
                name: 'sectorsLayer',
                source: sectorsSource,
                visible: true,
                style: normalStyle.bind(this, Settings.hidesectorfill)
            }),

            new ol.layer.Vector({
                name: 'poiLayer',
                source: poiLayerSource,
                style: getPoiLayerStyle
            }),

            new ol.layer.Vector({
                name: 'extentLayer',
                source: extentLayerSource,
                visible: false
            })

        ];

        mapInitOptions.view = new ol.View({
            projection: mapOptions.viewOpts.projection,
            center: ol.extent.getCenter(mapOptions.bbox),
            zoom: 8,
            minZoom: 4
        });

        callback(mapInitOptions);

    }

    function getText(feature, resolution, showLabel) {
        let text = '';
        if (showLabel)
            text = feature.get('name');

        return text;
    }

    function getMaxPoly(polys) {
        var polyObj = [];
        //now need to find which one is the greater and so label only this
        for (var b = 0; b < polys.length; b++) {
            polyObj.push({ poly: polys[b], area: polys[b].getArea() });
        }
        polyObj.sort(function (a, b) { return a.area - b.area });

        return polyObj[polyObj.length - 1].poly;
    }

    function normalStyle(hideFill, feature, resolution) {
        console.log(hideFill);
        let color = 'rgba(255, 255, 255, 0.4)';
        if (angular.isDefined(feature.get('color'))) {
            let hexColor = feature.get('color');
            color = ol.color.asArray('#' + hexColor);
            color = color.slice();
            color[3] = 0.4;
        }
        var textStyle = new ol.style.Style(getTextStyleConfig(feature, resolution, false));
        var style = new ol.style.Style(getPolyStyleConfig(color, 1, hideFill));
        return [style,textStyle];
    }

    function getTextStyleConfig(feature, resolution, showLabel) {
        return {
            text:new ol.style.Text({
                font: '12px sans-serif',
                text: getText(feature, resolution, showLabel),
                textBaseline: 'middle',
                textAlign: 'center',
                fill: new ol.style.Fill({
                    color: '#ffffff'
                }),
                stroke: new ol.style.Stroke({
                    color: '#ffffff',
                    width: 0.2
                }),
                overflow: true,
                backgroundFill: new ol.style.Fill({color: '#686868'}),
                backgroundStroke: new ol.style.Stroke({color: '#ffffff'}),
                padding: [3, 5, 3, 5]
            }),
            geometry: function(feature){
                var retPoint;
                if (feature.getGeometry().getType() === 'MultiPolygon') {
                    retPoint =  getMaxPoly(feature.getGeometry().getPolygons()).getInteriorPoint();
                } else if (feature.getGeometry().getType() === 'Polygon') {
                    retPoint = feature.getGeometry().getInteriorPoint();
                }
                return retPoint;
            }
        };
    }

    function getPolyStyleConfig(color, strokeWidth, hideFill) {
        var style = {stroke: new ol.style.Stroke({
            color: '#000000',
            width: strokeWidth
        })};
        if (!hideFill) {
            style.fill = new ol.style.Fill({
                color: color,
            })
        }
        return style;
    }

    function getLayerByName(name) {
        let returnLayer = null, layers = map.getLayers().getArray();

        layers.forEach(function (layer, idx, arr) {
            if (layer.get('name') && layer.get('name') === name) {
                returnLayer = layer;
            }
        });

        return returnLayer;
    };

    function zoomToExtent(extent) {
        if (map.getView().fitExtent) map.getView().fitExtent(extent, map.getSize()); //ol 3.2
        else map.getView().fit(extent, map.getSize());    //ol3.7
    }

    function zoomToLayerFeatures(layerName) {
        let layer = getLayerByName(layerName),
            extent = layer.getSource().getExtent();
        zoomToExtent(extent);
    }


    function getFeatureBy(layerName, featurePropertyName, featurePropertyValue) {
        let layer = getLayerByName(layerName),
            features = layer.getSource().getFeatures();

        for (let i = 0, l = features.length; i < l; i++) {
            if (features[i].get(featurePropertyName) == featurePropertyValue) {
                return features[i];
            }
        }
        return null;
    }

    function loadLayer() {
        getInitMapOptions(function (mapOptions) {
            initMap(mapOptions);
            addMarkerLayer();
        });
    }

    function zoomToSelectedFeaturesOfLayer(layerName, ids, field) {

        // if marker is set, don't zoom to Vector layers
        if (Settings.markerData.x !== null && Settings.markerData.y !== null) {
            return
        }


        let features = [];

        ids.forEach(function(id) {
            let feature = getFeatureBy(layerName, field, id);
            if (feature) {
                features.push(feature);
            }
        });

        if (features.length > 0) {
            extentLayerSource.addFeatures(features);
            zoomToLayerFeatures('extentLayer');
        }


    }


    function setLayersAndAreas() {

        $window.addEventListener('message', receiveMessage);

        extentLayerSource.clear();

        if (Settings.type === 'zones') {
            toggleLayer('zonesLayer', true);
            toggleLayer('districtsLayer', false);
            toggleLayer('sectorsLayer', false);

            var ids = Settings.ids;
            if (ids.zones.length > 0) {
                zoomToSelectedFeaturesOfLayer('zonesLayer', ids.zones, 'id');
            }
        }

        if (Settings.type === 'districts') {
            toggleLayer('districtsLayer', true);
            toggleLayer('zonesLayer', true);
            toggleLayer('sectorsLayer', false);

            var ids = Settings.ids;

            if (ids.districts.length > 0) {
                zoomToSelectedFeaturesOfLayer('districtsLayer', ids.districts, 'id');
            }
        }

        if (Settings.type === 'sectors') {
            toggleLayer('districtsLayer', false);
            toggleLayer('sectorsLayer', true);
            toggleLayer('zonesLayer', false);

            var ids = Settings.ids;

            if (ids.sectors.length > 0) {
                zoomToSelectedFeaturesOfLayer('sectorsLayer', ids.sectors, 'id');
            }

        }

        if (Settings.type === 'address') {
            toggleLayer('sectorsLayer', false);
            toggleLayer('districtsLayer', false);
        }
    }


    function preInitialize() {

        mapAPI.currentInteraction = null;
        mapAPI.dragMapInteraction = new ol.interaction.DragPan({kinetic: null});
        mapAPI.dragMapInteractionAdded = false;     //will be added by initialize method - for circle selection

    }

    function postInitialize() {

        if (Settings.markerData.x === null || Settings.markerData.y === null) {
            zoomToExtent(mapOptions.bbox);
        }
    }

    function zoomToSelectedFeatures(event){

        let selectionLayer = getLayerByName('selectionLayer');

        if (map.getView().fitExtent)
            map.getView().fitExtent(selectionLayer.getSource().getExtent(), map.getSize()); //ol 3.2
        else
            map.getView().fit(selectionLayer.getSource().getExtent(), map.getSize()); //ol3.7
    }

    function addExtraOlFunctions() {
        /**
         * This is a workaround.
         * Returns the associated layer.
         * @param {ol.Map} map.
         * @return {ol.layer.Vector} Layer.
         */
        ol.Feature.prototype.getLayer = function(map) {
            var this_ = this, layer_, layersToLookFor = [];
            /**
             * Populates array layersToLookFor with only
             * layers that have features
             */
            var check = function(layer){
                var source = layer.getSource();
                if(source instanceof ol.source.Vector){
                    var features = source.getFeatures();
                    if(features.length > 0){
                        layersToLookFor.push({
                            layer: layer,
                            features: features
                        });
                    }
                }
            };
            //loop through map layers
            map.getLayers().forEach(function(layer){
                if (layer instanceof ol.layer.Group) {
                    layer.getLayers().forEach(check);
                } else {
                    check(layer);
                }
            });
            layersToLookFor.forEach(function(obj){
                var found = obj.features.some(function(feature){
                    return this_ === feature;
                });
                if(found){
                    //this is the layer we want
                    layer_ = obj.layer;
                }
            });
            return layer_;
        };
    }

    function refreshPoiLayer() {

        let view = map.getView();
        let zoomLevel = view.getZoom();
        if(zoomLevel < 11){
            poiLayerSource.clear();
        }
        else{

            let bounds = view.calculateExtent(map.getSize());

            let url = getBaseUrl() + 'getPOILayers.php' ;
            let data = {};
            data.bounds = bounds;
            data.activePoiIds = activePoiIds;

            $http({
                method: 'POST',
                url: url,
                data: data,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'}
            }).then((response) => {
                    poiLayerSource.clear();
                    let entries = response.data;
                    let features = [];
                    entries.forEach(function (item) {
                        var feature = new ol.Feature({
                            geometry: new ol.geom.Point([item.lon, item.lat]),
                            br_id: item.br_id
                        });
                        features.push(feature);
                    });

                    poiLayerSource.addFeatures(features);
                    poiLayerSource.changed();
                });

        }


    }

    function setActivePoiIds(ids) {
        activePoiIds = ids;
    }

    function getPoiLayerStyle(feature, resolution) {

        let br_id = feature.get('br_id');


        var style = new ol.style.Style({
            image: new ol.style.Icon(({
                size: [19,14],
                opacity: 1,
                src: getBaseUrl() + 'src/assets/img/' + br_id + '.png'
            }))
        });

        return [style];

    }

    function toggleLayer(layerName, visible) {
        let layer = getLayerByName(layerName);

        if (angular.isDefined(layer)) {
            layer.setVisible(visible);
        }
    }

    function showLayer(layerName) {
        let layer = getLayerByName(layerName);
        if (angular.isDefined(layer)) {
            layer.setVisible(true);
        }
    }

    function hideLayer(layerName) {
        let layer = getLayerByName(layerName);
        if (angular.isDefined(layer)) {
            layer.setVisible(false);
        }
    }



}



// WEBPACK FOOTER //
// ./src/components/map/map.service.js